<div class="static contacts">
  <h1>Contacts</h1>
  <p><span>Company:</span><b class="title">DIGITAL DP LTD</b></p>
  <p><span>Company number:</span> <b>15914437</b></p>
  <p>
    <span>Address:</span>
    <b>
      82a James Carter Road, Mildenhall, Bury St. Edmunds, England, IP28 7DE
    </b>
  </p>
  <p>
    <span>E-mail:</span>
    <a href="mailto:info&#64;imagebase.pro">info&#64;imagebase.pro</a>
  </p>
  <div class="static__social">
    <app-social-links classes="social_static" />
  </div>
</div>
